import { Component, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';
import { OpenIdConnectService } from '../../services/oidc/open-id-connect.service';
import { Router, Route } from '@angular/router';
import * as _config from '../../services/config';

@Component({
    selector: 'app-nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent {
    appTitle = _config.appTitle;
    isExpanded = false;

    collapse() {
        this.isExpanded = false;
    }

    toggle() {
        this.isExpanded = !this.isExpanded;
    }

    name = "";

    get routes(): Route[] {
        var foundRoutes: Route[] = [];

        if (this.router) {
            this.router.config.forEach(r => {
                if (r.data && r.data["order"]) {
                    if (typeof r.data["admin"] === 'undefined' || !r.data["admin"] || this.oidcService.profile.isAdmin)
                        foundRoutes.push(r);
                }

                if (r.children && r.children.length) {
                    r.children.forEach(c => {
                        if (c.data && c.data["order"]) {
                            if (typeof c.data["admin"] === 'undefined' || !c.data["admin"] || this.oidcService.profile.isAdmin)
                                foundRoutes.push(c);
                        }
                    })
                }
            })
        }

        return foundRoutes.sort((a, b) => {
            return Number(a.data["order"]) == Number(b.data["order"]) ? 0 : Number(a.data["order"]) < Number(b.data["order"]) ? -1 : 1;
        });
    }

    constructor(public oidcService: OpenIdConnectService, public router: Router) {
        this.oidcService.userLoaded$.subscribe((userLoaded) => {
            if (userLoaded) {
                this.name = this.oidcService.profile.name;
            }
        });

    }
}
